import ReferenceInterface from '../../interfaces/client/Reference'
import ReferenceCollectionInterface from '../../interfaces/client/ReferenceCollection'

export default (
  allReferences: ReferenceCollectionInterface,
  newReference: ReferenceInterface
): ReferenceCollectionInterface => {
  const newReferenceKey = Object.keys(newReference)[0]
  const existingReference = allReferences[newReferenceKey]

  if (existingReference) {
    return {
      ...allReferences,
      [newReferenceKey]: [
        ...Object.values(existingReference),
        ...Object.values(newReference),
      ],
    }
  }

  return {
    ...allReferences,
    [newReferenceKey]: Object.values(newReference),
  }
}
